export default __webpack_public_path__ + "static/images/add-9ab99364055ddb3b102d2a916fc23073.png";